import { JustpayPaymentEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-payment-endpoint-service"
import { format } from "date-fns-tz"
import { JustpayPaymentModel } from "@/views/loyalty/models/justpay-payment.model"

export class JustpayPaymentService {
    constructor () {
        this.justpayPaymentEndpointService = new JustpayPaymentEndpointService()
    }

    async changePayment (jsonObject) {
        const payment = await this.justpayPaymentEndpointService.changePayment(jsonObject)
        return payment || {}
    }

    async getAllPayments () {
        const payments = await this.justpayPaymentEndpointService.getAllPayments()
        return payments || []
    }

    async getCheque (paymentId) {
        const cheque = await this.justpayPaymentEndpointService.getCheque(paymentId)
        return cheque || {}
    }

    async getPayments (clientId, filter_date, tableOptions) {
        let payments = null
        if (tableOptions !== undefined) {
            payments = await this.justpayPaymentEndpointService.getPaymentsByClient(clientId, filter_date, [1, 2, 4, 8, 10], tableOptions)
        } else {
            payments = await this.justpayPaymentEndpointService.getPaymentsByClient(clientId, filter_date, [1, 2, 4, 8, 10], {
                page: 1,
                itemsPerPage: 10
            })
        }
        if (payments) {
            const prepared_payments = payments.data.map(m => {
                const paymentModel = new JustpayPaymentModel()
                paymentModel.id = m.id
                paymentModel.created = format(new Date(m.created), "dd.MM.yyyy HH:mm")
                paymentModel.sum = Number(m.payments.map(payment => payment.sum).reduce((a, b) => a + b, 0)).money()
                paymentModel.items_name = m.items.map(item => `${item.name} `).toString()
                paymentModel.point_name = m.point.name
                paymentModel.type = m.payments.map(payment => {
                    switch (payment.type) {
                        case 0:
                            return 'Наличные'
                        case 1:
                            return 'Карта оплаты'
                        case 2:
                            return 'СБП'
                    }
                })
                return paymentModel
            })
            return { count: payments.count, payments: prepared_payments }
        } else { return { count: 0, payments: [] } }
    }

    async getFaultPayments (clientId, filter_date, tableOptions) {
        let payments = null
        if (tableOptions !== undefined) {
            payments = await this.justpayPaymentEndpointService.getPaymentsByClient(clientId, filter_date, [5, 6, 7, 9, 11], tableOptions)
        } else {
            payments = await this.justpayPaymentEndpointService.getPaymentsByClient(clientId, filter_date, [5, 6, 7, 9, 11], {
                page: 1,
                itemsPerPage: 10
            })
        }
        // console.log('getPaymentsByClient payments:', payments)
        if (payments) {
            const prepared_payments = payments.data.map(m => {
                const paymentModel = new JustpayPaymentModel()
                paymentModel.id = m.id
                paymentModel.date = format(new Date(m.created), "dd.MM.yyyy HH:mm") // before was m.date
                paymentModel.sum = Number(m.payments.map(payment => payment.sum).reduce((a, b) => a + b, 0)).money()
                paymentModel.items_name = m.items.map(item => `${item.name} `).toString()
                paymentModel.point_name = m.point.name
                switch (m.state) {
                    case (5):
                    paymentModel.state = 'Ошибка ККТ'
                        break
                    case (6):
                        paymentModel.state = 'Ошибка ПС'
                        break
                    case (7):
                        paymentModel.state = 'Отменено'
                        break
                    case (9):
                        paymentModel.state = 'Ошибка сети'
                        break
                    case (11):
                        paymentModel.state = 'Отменено банком'
                        break
                }
                paymentModel.type = m.payments.map(payment => {
                switch (payment.type) {
                    case 0:
                        return 'Наличные'
                    case 1:
                        return 'Карта оплаты'
                    case 2:
                        return 'СБП'
                }
})
                return paymentModel
            })
            console.log('prepared_payments', prepared_payments)
            return {
                count: payments.count,
                payments: prepared_payments
            }
        } else return { count: 0, payments: {} }
    }

    async getForFiltering () {
        const payments = await this.justpayPaymentEndpointService.getForFiltering()
        return payments || []
    }

    async getPayment (jsonObject) {
        const payment = await this.justpayPaymentEndpointService.getPayment(jsonObject)
        return payment || {}
    }

    // async getOfflinePoints (clientId, filter_date, tableOptions) {
    //     let payments = null
    //     if (tableOptions !== undefined) {
    //         payments = await this.justpayPaymentEndpointService.getPaymentsByClient2(clientId, tableOptions)
    //     } else {
    //         payments = await this.justpayPaymentEndpointService.getPaymentsByClient2(clientId, {
    //             page: 1,
    //             itemsPerPage: 10
    //         })
    //     }
    //     const prepared_payments = payments.data.map(m => {
    //         const paymentModel = new JustpayPaymentModel()
    //         const diff = differenceInMinutes(Date.now(), new Date(m.date))
    //         console.log('diff', diff)
    //         // const currentMinute = Date.now().getMinutes()
    //         // const dbMinute = new Date(m.date).getMinutes()
    //         // paymentModel.date = format(new Date(m.date), "dd.MM.yyyy HH:mm")
    //         // paymentModel.sum = m.payments.map(payment => payment.sum).reduce((a, b) => a + b, 0) / 100
    //         // paymentModel.items_name = m.items.map(item => `${item.name} `).toString()
    //         if (diff > 5) {
    //             paymentModel.point_name = m.point.name
    //             paymentModel.address = m.point.place_item.address
    //             return paymentModel
    //         }
    //     })
    //     console.log('getOfflinePoints prepared_payments', prepared_payments)
    //     return { count: payments.count, payments: prepared_payments }
    // }
}
